import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Facebook, Phone, Mail, MapPin } from 'lucide-react';

export default function Footer() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (sectionId) => {
    if (location.pathname === '/') {
      const element = document.getElementById(sectionId);
      if (element) {
        const offset = 80;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    } else {
      navigate(`/#${sectionId}`);
    }
  };

  return (
    <footer className="bg-[#f1f1f1] border-t border-slate-200/80 pt-16 pb-8 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 pb-12 border-b border-slate-200/80">
          
          {/* Logo & Description */}
          <div className="md:col-span-4 space-y-4">
            <div className="flex items-center gap-3">
              <img 
                src="https://assets.auxodev.dk/assets/e2460b72-5386-46d7-9851-4a7b448e2c89/69bff1cf-990c-49a8-9f87-490bfe4d5aa8.png" 
                alt="Balsby Montage ApS Logo" 
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-sm text-slate-600 max-w-xs leading-relaxed">
              Professionelt smede- og montagearbejde i særklasse. Vi leverer holdbare og præcise løsninger til tiden.
            </p>
            {/* Facebook Link */}
            <div className="flex items-center gap-3 pt-2">
              <a 
                href="https://facebook.com/balsbymontage" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-600 hover:text-black transition-colors"
                aria-label="Følg os på Facebook"
              >
                <Facebook className="h-6 w-6" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-3 space-y-4">
            <h4 className="text-lg sm:text-xl font-medium text-slate-900 uppercase tracking-wider">Hurtige links</h4>
            <ul className="space-y-2">
              <li>
                <button 
                  onClick={() => handleNavClick('ydelser')} 
                  className="text-sm text-slate-600 hover:text-[#487aad] transition-colors cursor-pointer text-left"
                >
                  Vores ydelser
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('om-os')} 
                  className="text-sm text-slate-600 hover:text-[#487aad] transition-colors cursor-pointer text-left"
                >
                  Hvem er vi?
                </button>
              </li>
              <li>
                <button 
                  onClick={() => handleNavClick('kontakt')} 
                  className="text-sm text-slate-600 hover:text-[#487aad] transition-colors cursor-pointer text-left"
                >
                  Kontakt os
                </button>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div className="md:col-span-5 space-y-4">
            <h4 className="text-lg sm:text-xl font-medium text-slate-900 uppercase tracking-wider">Kontaktinformation</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-[#487aad] shrink-0 mt-0.5" />
                <a href="tel:+4593872382" className="hover:text-[#487aad] transition-colors font-semibold">
                  Tlf.: 93 87 23 82
                </a>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#487aad] shrink-0 mt-0.5" />
                <a href="mailto:balsbymontage@gmail.com" className="hover:text-[#487aad] transition-colors break-all font-semibold">
                  Mail: balsbymontage@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#487aad] shrink-0 mt-0.5" />
                <span>Adresse: Fladhøjvej 1, 6818 Årre</span>
              </li>
            </ul>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Balsby Montage ApS. Alle rettigheder forbeholdes.</p>
          <div className="flex items-center gap-4">
            <span>CVR: 43732358</span>
            <span>·</span>
            <span>Dansk Håndværk</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
